module.exports = __webpack_public_path__ + "static/media/66900010-0bE0wSgs.252c14ab.JPG";